import { makeStyles } from "@fluentui/react-components";
import { useParams } from "react-router";
import { useFetchReviewsQuery } from "../Api/Reviews/reviewSlice";
import NotFound from "../Shared/NotFound";
import ReviewBody from "./ReviewBody";
import ReviewFooter from "./ReviewFooter";
import ReviewHeader from "./ReviewHeader";

const useStyles = makeStyles({
	root: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		rowGap: '15px'
	},
	header: {
		flexShrink: 0
	},
	body: {
		overflowY: 'auto'
	},
	footer: {
		marginTop: 'auto'
	}
});

const ReviewPage = () => {
	const styles = useStyles();
	const { reviewid } = useParams();
	const { review, isLoading } = useFetchReviewsQuery({ reviewId: Number(reviewid) }, {
		selectFromResult: ({ data, isLoading, isError }) => ({
			review: data && data.length > 0 ? data[0] : undefined,
			isLoading,
			isError
		})
	});

	return (
		<>
			{
				(!reviewid || (!review && !isLoading)) && <NotFound />
			}
			{
				reviewid && review &&
				<div className={styles.root}>
					<div className={styles.header}>
						<ReviewHeader review={review} />
					</div>

					<div className={styles.body}>
						<ReviewBody review={review} />
					</div>

					<div className={styles.footer}>
						<ReviewFooter
							user={review.username}
							gameId={review.videoGameId}
							gameTitle={review.videoGameTitle}
						/>
					</div>

				</div>
			}

		</>
	);
}

export default ReviewPage;